import { render, staticRenderFns } from "./EventPhotoQuota.vue?vue&type=template&id=60f1106b&scoped=true"
import script from "./EventPhotoQuota.vue?vue&type=script&lang=js"
export * from "./EventPhotoQuota.vue?vue&type=script&lang=js"
import style0 from "./EventPhotoQuota.vue?vue&type=style&index=0&id=60f1106b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1106b",
  null
  
)

export default component.exports